import React from 'react'
import { Create } from 'react-admin'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import OrganizationForm from './OrganizationForm'

const OrganizationCreate: React.FC = () => {
  return (
    <SectionWrapper>
      <Create>
        <OrganizationForm />
      </Create>
    </SectionWrapper>
  )
}

export default OrganizationCreate
